module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Pro Stat","description":"This is an exclusive stat for Swiset Pro users","btnSeeBenefits":"See Pro Benefits"},"es":{"title":"Estadística Pro","description":"Es una estadística exclusiva para usuarios Swiset Pro","btnSeeBenefits":"Mira los Beneficios Pro"}}')
  delete Component.options._Ctor
}
